// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3ae09cf","239":"3a18948a","732":"7c7d3284"}[chunkId] + ".chunk.js";
};